import { useCreditsExhaustedTopUp } from '../hooks/useCreditsExhaustedTopUp'
import { CreditsExhaustedNotice } from './CreditsExhaustedNotice'

/**
 * Out-of-credits state for a chat composer: replaces the input with a blocking
 * banner + top-up CTA (no typing). Shared by AssistantChat and SideChat so the
 * two composers stay identical.
 */
export function ComposerCreditBlock() {
  const handleTopUp = useCreditsExhaustedTopUp({ modalSource: 'chat_blocked' })

  return <CreditsExhaustedNotice variant="card" onTopUp={handleTopUp} />
}
